export const captureAPMError = (error: unknown) => {
  // Cast `error` as `Error` to avoid type errors
  const typedError = error as Error;

  if (
    typeof window !== "undefined" &&
    window?.elasticApm?.captureError &&
    typeof window.elasticApm.captureError === "function"
  ) {
    window.elasticApm.captureError(typedError);
  }
};
